import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import moment from "moment";
import Label from "./Label";
import { TimelineLabelType } from "../../../../constants/ComponentTypes";

const labelConfigs = [
  {
    key: "appointment",
    userIds: "appointment_user_ids",
    userNames: "appointment_user_names",
    type: TimelineLabelType.APPOINTMENT,
  },
  {
    key: "connect",
    userIds: "connect_user_ids",
    userNames: "connect_user_names",
    type: TimelineLabelType.CONNECT,
  },
  {
    key: "non_connect",
    userIds: "non_connect_user_ids",
    userNames: "non_connect_user_names",
    type: TimelineLabelType.NON_CONNECT,
  },
  {
    key: "sent_document",
    userIds: "sent_document_user_ids",
    userNames: "sent_document_user_names",
    type: TimelineLabelType.SENT_DOCUMENT,
  },
  {
    key: "qr_code_reaction",
    userIds: "qr_code_reaction_user_ids",
    userNames: "qr_code_reaction_user_names",
    type: TimelineLabelType.QR_CODE_REACTION,
  },
  {
    key: "close",
    userIds: "close_user_ids",
    userNames: "close_user_names",
    type: TimelineLabelType.CLOSE,
  },
  {
    key: "declined",
    userIds: "declined_user_ids",
    userNames: "declined_user_names",
    type: TimelineLabelType.DECLINED,
  },
  {
    key: "approach_ng",
    userIds: "approach_ng_user_ids",
    userNames: "approach_ng_user_names",
    type: TimelineLabelType.APPROACH_NG,
  },
];

const styles = () => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginLeft: "5px",
  },
});

const LabelsContainer = ({ classes, item }) => {
  const relocationAtDiff = moment.duration(moment().diff(moment(item.relocation_at.date)));
  const createdAtDiff = moment.duration(moment().diff(moment(item.created_at)));
  const dayCountAWeek = 7;
  const showNewLabel = relocationAtDiff.as("days") <= dayCountAWeek ||
    (moment(item.relocation_at.date).isSame(item.created_at, 'month') &&
    createdAtDiff.as("days") <= dayCountAWeek);
  const showRetirementRiskLabel = item.has_retirement_risk;

  return (
    <div className={classes.root}>
      {showNewLabel && (
        <Label
          labelText="NEW"
          toolTipText="新任はキーマンデータベースに更新されてから1週間以内のデータです"
          labelBgColor="#FFC62B"
        />
      )}
      {!!showRetirementRiskLabel && (
        <Label
          labelText="退任リスクあり"
          toolTipText="同一役職のキーマンが他に就任した場合退任リスクがあるとみなします。"
          labelBgColor="#FF6B6B"
        />
      )}
      {labelConfigs.map(
        ({ userIds, userNames, type, key }) =>
          item[userIds] &&
          item[userIds].length > 0 && (
            <Label
              key={key}
              labelText={type.text}
              toolTipText={(item[userNames] || []).join(', ')}
              labelBgColor={type.color}
            />
          )
      )}
    </div>
  );
};

LabelsContainer.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
};

export default withStyles(styles)(LabelsContainer);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/Spreadsheet/parts/LabelsContainer.jsx